var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MdtModalConfirmation',{attrs:{"title":_vm._f("translate")('admin_activate_application'),"info-msg":_vm.infoMsg,"btn-text":_vm._f("translate")('admin_activate'),"type":"success"},on:{"close":function($event){return _vm.$emit('close')},"confirm":_vm.activateApplications}},[(_vm.loading)?_c('MdtLoader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }